export default "__VITE_ASSET__BdTojDlO__"